export const settings = {
  accountCompletionModal: {
    action: {
      complete: 'Voltooien',
      next: 'Volgende',
      save: 'Opslaan',
    },
    description: 'Vul je gegevens aan, zodat je snel kan beginnen met factureren.',
    financialInfo: {
      description: 'Vul hieronder je rekeningnummer in.',
      tab: 'Bankgegevens',
    },
    frameworkAgreement: {
      error: 'Er ging iets mis bij het tekenen van je overeenkomst.',
      tab: 'Raamovereenkomst',
    },
    peppol: {
      checkAgain: 'Check mijn Peppol-inbox',
      description:
        '<paragraph>Om facturen te versturen via Creative Shelter heb je een <bold>actieve Peppol-inbox</bold> nodig. Die heb je op dit moment nog niet.</paragraph>\n<paragraph>Zonder Peppol-inbox kunnen we je factuur niet versturen. Activeer eerst je Peppol-inbox bij een erkende provider.</paragraph>\n<paragraph>Zodra je Peppol-inbox geactiveerd is, kunnen wij je Peppol-ID automatisch terugvinden. Heb je dat al in orde gebracht? Dan kan je hieronder opnieuw laten checken.</paragraph>',
      tab: 'Peppol-inbox',
    },
    successModal: {
      createFirstInvoice: 'Maak je eerste factuur',
      description: 'Je bent nu klaar om je factuur of offerte te versturen!',
      title: 'Je account is klaar',
    },
    title: 'Vervolledig je account',
    vatRegulation: {
      error: 'Er ging iets mis bij het opslaan van je btw-statuut.',
      tab: 'Btw-statuut',
    },
  },
  alerts: {
    brands: {
      successCreated: 'Je handelsnaam is aangemaakt.',
      successDeleted: 'Je handelsnaam is verwijderd.',
      successFavorite: 'Je favoriete handelsnaam is gewijzigd.',
      successUpdated: 'Je handelsnaam is bewerkt.',
    },
    community: {
      errorProfilePictureDeleted:
        'Er ging iets mis bij het verwijderen van je Community-profielfoto. Neem contact op met service@creativeshelter.be als het probleem zich blijft voordoen.',
      errorProfilePictureTooLarge: 'De afbeelding die je wilt uploaden mag niet groter zijn dan 5 MB.',
      errorProfilePictureUploaded:
        'Er ging iets mis bij het uploaden van je Community-profielfoto. Neem contact op met service@creativeshelter.be als het probleem zich blijft voordoen.',
      errorUpdated:
        'Er ging iets mis bij het updaten van je Community-profiel. Neem contact op met service@creativeshelter.be als het probleem zich blijft voordoen.',
      successProfilePictureDeleted: 'Je Community-profielfoto is verwijderd.',
      successProfilePictureUploaded: 'Je Community-profielfoto is gewijzigd.',
    },
    customConditions: {
      successDeleted: 'Je custom algemene voorwaarden zijn verwijderd.',
    },
    errorActivities: 'Er ging iets mis bij het opslaan van je activiteiten.',
    errorPersonalInfo: 'Er ging iets mis bij het opslaan van je profielinformatie.',
    integrations: {
      successAccountantLinked: 'Je boekhouder is toegevoegd.',
      successAccountantUnlinked: 'Je boekhouder is verwijderd.',
      successBillitPaired: 'Je boekhoudpakket is toegevoegd.',
      successCashacaPaired: 'Cashaca is gekoppeld.',
      successForwardingEmailLinked: 'Het e-mailadres is toegevoegd.',
      successForwardingEmailUnlinked: 'Het e-mailadres is verwijderd.',
    },
    invalidFields: 'Niet alles is correct ingevuld. Controleer de aangeduide velden.',
    numberingSeries: {
      duplicateFormat: 'Het formaat van deze nummeringreeks heb je al gebruikt, kies je een nieuwe?',
      successCreated: 'Je nummeringreeks is aangemaakt.',
      successDeleted: 'Je nummeringreeks is verwijderd.',
      successUpdated: 'Je nummeringreeks is bewerkt.',
    },
    successUpdated: 'Je instellingen zijn opgeslagen.',
    validFinancialInfo: 'Geldige bankgegevens',
  },
  breadcrumb: {
    documents: 'Documenten',
    invitations: 'Uitnodigingen',
    pricing: 'Vergoeding',
    root: 'Instellingen',
  },
  documents: {
    headers: {
      name: 'Bestandsnaam',
      type: 'Type',
    },
    title: 'Documenten',
  },
  edit: 'Aanpassen',
  fields: {
    accountantEmail: {
      label: 'E-mailadres van je boekhouder',
      placeholder: 'E-mailadres',
    },
    activities: {
      other: {
        label: 'Vul hier je extra creatieve activiteiten in',
      },
      primary: {
        label: 'Hoofdactiviteit',
      },
      secondary: {
        label: 'Extra activiteiten',
      },
    },
    brandId: {
      label: 'Handelsnaam',
    },
    brandName: {
      label: 'Handelsnaam',
      placeholder: 'Je handelsnaam',
    },
    city: {
      label: 'Gemeente',
    },
    color: {
      label: 'Kleur',
    },
    communityDescription: {
      label: 'Stel jezelf en/of je activiteiten kort voor',
    },
    communityEmail: {
      label: 'Publiek e-mailadres',
    },
    communityLinks: {
      label: 'Links',
      placeholders: {
        behance: 'https://www.behance.net/',
        facebook: 'https://www.facebook.com/',
        instagram: 'https://www.instagram.com/',
        linkedIn: 'https://www.linkedin.com/in/',
        website: 'https://',
      },
    },
    communityOpenToWork: {
      label: 'Ik ben beschikbaar voor opdrachten',
    },
    communityRegion: {
      label: 'Regio',
      placeholder: 'Niet gespecificeerd',
    },
    companyName: {
      label: 'Bedrijfsnaam',
    },
    currentPassword: {
      label: 'Huidig wachtwoord',
    },
    email: {
      label: 'E-mailadres',
      placeholder: 'E-mailadres',
    },
    firstName: {
      label: 'Voornaam',
      placeholder: 'Voornaam',
    },
    forwarding: {
      alerts: {
        billtobox:
          'Voeg je ‘administratie@creativeshelter.be’ toe als een gekend e-mailadres in Billtobox? Dan verloopt alles meteen goed!',
      },
      frequency: {
        label: 'Frequentie',
        options: {
          instant: 'Per factuur of creditnota (.pdf/.xml)',
          monthly: 'Per maand (.zip)',
          quarterly: 'Per kwartaal (.zip)',
        },
        tooltip:
          'Als je een boekhoudpakket ingaf, kies dan voor de optie om per factuur of creditnota een pdf- en xml-bestand door te sturen.',
      },
      platformEmail: {
        label: 'E-mailadres van je Accountable-account',
        tooltip: 'Accountable herkent op basis van dit e-mailadres tot welk account je facturen en creditnota’s behoren.',
      },
    },
    lang: {
      label: 'Taal',
    },
    lastName: {
      label: 'Achternaam',
      placeholder: 'Achternaam',
    },
    logo: {
      error: {
        delete: 'Er ging iets mis bij het verwijderen van het logo. Probeer je het later nog eens?',
        tooLarge: 'Het logo dat je probeert te uploaden mag niet groter zijn dan 5 MB.',
        upload: 'Er ging iets mis bij het uploaden van het logo.',
      },
      label: 'Logo handelsnaam',
      tooltip:
        'Als je deze handelsnaam selecteert bij het opstellen van een document, wordt dit logo gebruikt in plaats van het logo van je hoofdhandelsnaam.',
    },
    mainOccupation: {
      label: 'Je statuut als zelfstandige',
      options: {
        '0': 'Bijberoep',
        '1': 'Hoofdberoep',
      },
    },
    newPassword: {
      label: 'Nieuw wachtwoord',
    },
    newPasswordConfirmation: {
      label: 'Bevestig nieuw wachtwoord',
    },
    number: {
      label: 'Huisnummer',
    },
    numberingSeries: {
      blocker: 'Ben je zeker dat je de pagina wilt verlaten? De wijzigingen aan je nummeringreeks zijn niet opgeslagen.',
      format: {
        amountOfDigits: {
          label: 'Aantal cijfers',
          option: '{{amountOfDigits}} cijfers',
        },
        lengthWarning: 'We raden aan de lengte van het nummer te beperken tot {{limit}} karakters.',
        nextNumber: 'Het volgende nummer in deze reeks is <strong>{{number}}</strong>',
        prefixText: {
          label: 'Voorvoegsel',
        },
        separator: {
          label: 'Scheidingsteken',
          none: 'Geen',
        },
        suffixText: {
          label: 'Achtervoegsel',
        },
        useSuffix: 'Achtervoegsel gebruiken',
        year: {
          label: 'Jaar/maand',
          options: {
            YY: 'Jaar kort ({{yearMonth}})',
            YYMM: 'Jaar kort + maand ({{yearMonth}})',
            YYYY: 'Jaar ({{yearMonth}})',
            YYYYMM: 'Jaar + maand ({{yearMonth}})',
            none: 'Geen',
          },
        },
      },
      name: {
        label: 'Naam',
        placeholder: 'Bv. Verkoopfacturen',
        tooltip: 'Geef je nummeringreeks een naam, zo herken je deze snel.',
      },
      resetInterval: {
        description: 'Reset de telling automatisch naar 1.',
        label: 'Telling herstarten',
        options: {
          monthly: 'Maandelijks',
          never: 'Nooit',
          yearly: 'Jaarlijks',
        },
      },
      startAt: {
        label: 'Startnummer',
      },
      type: {
        label: 'Type',
        options: {
          both: 'Facturen en creditnota’s',
          credit_notes: 'Creditnota’s',
          invoices: 'Facturen',
        },
        tooltip:
          'In je boekhouding bestaan er twee belangrijke soorten documenten: je facturen en je creditnota’s. Je kan één nummeringreeks gebruiken voor beide, maar een opsplitsing kan ook. Dat laten we aan jou over.',
      },
    },
    phone: {
      label: 'Telefoonnummer',
      placeholder: '+32 499 99 99 99',
    },
    street: {
      label: 'Straat',
    },
    vatID: {
      label: 'Btw-nummer',
    },
    zipcode: {
      label: 'Postcode',
    },
  },
  general: {
    customConditions: {
      create: 'Nieuwe voorwaarden',
      delete: {
        action: 'Verwijder custom algemene voorwaarden',
        description: 'Ben je zeker dat je de custom algemene voorwaarden “{{name}}” wilt verwijderen?',
        title: 'Custom algemene voorwaarden verwijderen',
      },
      description: 'Bekijk hier het overzicht van al je custom algemene voorwaarden of maak er één aan.',
      table: {
        actions: {
          creatingPdf: 'Pdf aan het genereren…',
          delete: 'Verwijderen',
          view: 'Bekijken',
        },
        name: 'Naam',
      },
      title: 'Custom algemene voorwaarden',
      wizard: {
        already_agreement: {
          question: 'Heb je al afgesproken met je klant over hoe je werk mag gebruikt worden?',
        },
        already_agreement_no: {
          question: 'No worries! Aan de hand van volgende vragen bepaal jij wat je klant met je werk mag doen.',
        },
        already_agreement_no_paper: {
          question: 'No worries! Aan de hand van volgende vragen zetten we ze op papier voor jou.',
        },
        already_agreement_paper: {
          question: 'Heb je die afspraken op papier?',
        },
        already_agreement_yes_paper: {
          question:
            "Perfect, goede afspraken maken goede vrienden. Duid in het profiel van de klant aan dat je al een bestaande overeenkomst hebt en bezorg ons deze via e-mail (<a href='mailto:administratie@creativeshelter.be'>administratie@creativeshelter.be</a>). Wij nemen deze overeenkomst graag voor je onder de loep, en tekenen mee als derde partij.",
        },
        common_answers: {
          close: 'Oké, sluit de wizard',
          next: 'Oké, volgende vraag',
          no: 'Nee',
          ok: 'Oké',
          previous: 'Vorige vraag',
          start_questions: 'Oké, start de vragen',
          yes: 'Ja',
        },
        modify_how: {
          options: {
            '0': 'Te bewerken/wijzigen door elementen toe te voegen en/of weg te laten.',
            '1': 'Te vertalen/om te zetten.',
          },
          question: 'Hoe mag je werk bewerkt of gewijzigd worden?',
        },
        overview: {
          finish: 'Oké, maak mijn custom algemene voorwaarden aan.',
          name: {
            label:
              'Geef hier de naam in van je nieuwe custom algemene voorwaarden. Dit kan de naam van de klant bevatten of de specifieke afspraken.',
            placeholder: 'Bijvoorbeeld ‘Gebruiksrecht Benelux 1 jaar’',
          },
          question: 'Bedankt, dat waren alle vragen! Hier kan je nog een overzicht terugvinden van je antwoorden:',
        },
        reproduce_how: {
          options: {
            '0': 'Op eender welke wijze, in eender welke vorm, met alle technieken en op alle dragers.',
            '1': 'In een specifieke vorm.',
            '2': 'In elektronische vorm op vaste informatiedrager.',
            '3': 'In elektronische vorm op online informatiedrager.',
          },
          other_placeholder: 'Specificeer je in welke vorm?',
          question: 'Op welke manier mag je werk gereproduceerd worden?',
        },
        reproduce_how_many: {
          options: {
            '0': 'Onbeperkt',
            '1': 'Beperkt',
          },
          other_placeholder: 'Specificeer het aantal',
          question: 'Op hoeveel exemplaren mag je werk gereproduceerd worden?',
        },
        share_how: {
          options: {
            '0': 'Publiceren in …',
            '1': 'Ter beschikking via …',
            '2': 'Opnemen in een boek, catalogus, …',
            '3': 'Als promomateriaal en voor commerciële doeleinden.',
          },
          other_placeholder: 'Specificeer',
          question: 'Op welke manier mag je werk meegedeeld worden?',
        },
        start: {
          description: 'Volg onderstaande wizard om je eigen custom algemene voorwaarden samen te stellen.',
          ok: 'Oké, start de wizard',
          title: 'Maak je custom algemene voorwaarden',
        },
        thanks: {
          close: 'Sluit de wizard',
          explanation:
            'Maak je factuur aan en selecteer de naam van je custom AV’s onderaan het keuzemenu ‘afspraak auteursrechten’. Je AV’s op maat zijn automatisch opgenomen in de bijlage die we samen met onze factuur aan je klant sturen onder artikel 8 (8.1 tot en met 8.3). Ook in het veld bijzondere voorwaarden op onze factuur aan je klant wordt er verwezen naar custom AV’s.',
          question:
            'Je custom algemene voorwaarden worden nu voor je gemaakt. Je kan ze binnenkort bekijken en gebruiken bij de aanmaak van je factuur!',
          subtitle: 'Hoe ga ik aan de slag?',
        },
        transfer_copyright: {
          question: 'Wil je je auteursrechten op je werk overdragen aan je klant?',
        },
        transfer_copyright_no: {
          question: 'Oké top, je dient dan aan te geven wat er met je werk mag gebeuren.',
        },
        transfer_copyright_yes: {
          question: 'Oké, ideaal! Kies dan voor ‘overdracht’ bij het aanmaken van een offerte of factuur.',
        },
        use_how: {
          options: {
            '0': 'Reproducties maken',
            '1': 'Publiekelijk meedelen',
            '2': 'Bewerken/wijzigen',
          },
          question: 'Wat mag je klant doen met je werk?',
        },
        use_how_long: {
          options: {
            '0': 'Volledige duurtijd',
            '1': 'Andere periode',
          },
          other_placeholder: 'Specificeer de periode',
          question: 'Hoe lang mag je klant je werk gebruiken?',
        },
        use_where: {
          options: {
            '0': 'België',
            '1': 'Europa',
            '2': 'De hele wereld',
            '3': 'Andere',
          },
          other_placeholder: 'Bijvoorbeeld Benelux',
          question: 'Waar mag je klant je werk gebruiken?',
        },
      },
    },
    description: 'Wijzig de lay-out en de werking van je platform.',
    email: {
      bcc: {
        description:
          'Dit houdt in dat je in bcc staat bij alle e-mails die we naar je klanten versturen, van nieuwe offertes, facturen en creditnota’s tot betalingsherinneringen van facturen.',
        title: 'Zet mij in bcc bij alle e-mails naar mijn klanten',
      },
      description: 'Kies hier welke e-mails en notificaties je wilt ontvangen',
      followUpEnabled: {
        description: 'Ontvang een melding als er een update is over de betalingsopvolging van een vervallen factuur',
        title: 'Update betalingsopvolgingen',
      },
      invitationReminder: {
        description:
          'Krijg een reminder als de collega-freelancer die je uitnodigde, op zijn of haar beurt een herinnering krijgt om zich te registreren.',
        title: 'Herinnering over verstuurde uitnodigingen',
      },
      jobPostUpdates: {
        description:
          'Ontvang wekelijks een overzicht van nieuwe (en nog niet ingevulde) opdrachten op basis van je hoofd- en nevenactiviteiten.',
        title: 'Wekelijks overzicht nieuwe opdrachten',
      },
      nettoSaved: {
        description:
          'Krijg een overzicht van wat je maandelijks bespaart door Creative Shelter te gebruiken. Zo zie je zwart op wit wat je extra verdient door je auteursrechten te verzilveren.',
        title: 'Maandelijkse e-mail over nettobesparingen',
      },
      title: 'E-mails & notificaties',
    },
    numberingSeries: {
      add: 'Nieuwe nummeringreeks',
      delete: {
        description: 'Ben je zeker dat je “{{numberingSeries}}” wilt verwijderen?',
        title: 'Nummeringreeks verwijderen',
      },
      description:
        'Systeem voor het automatisch nummeren van je facturen en creditnota’s. Vragen of graag meer info? <a href="https://knowledge.creativeshelter.be/wat-is-een-nummeringreeks-en-hoe-stel-ik-deze-in" target="_blank">Dat vind je hier</a>.',
      edit: {
        format: 'Formaat/opties wijzigen',
        name: 'Naam/type wijzigen',
      },
      headers: {
        name: 'Naam',
        nextNumber: 'Volgend nummer',
        type: 'Type',
      },
      title: 'Nummeringreeksen',
    },
    themeInvoice: {
      colorTheme: {
        helpText: 'Kies een kleurencombinatie voor de documenten naar je klanten.',
        subtitle: 'Kleurenthema',
      },
      logo: {
        helpText: 'Laad hier het logo van je eenmanszaak op.',
      },
      title: 'Factuurthema',
    },
    title: 'Instellingen',
  },
  header: {
    save: 'Wijzigingen opslaan',
    title: 'Instellingen',
  },
  imageUpload: {
    logo: {
      delete: 'Logo verwijderen',
      label: 'Logo',
      upload: 'Logo uploaden',
    },
    profilePicture: {
      delete: 'Foto verwijderen',
      label: 'Profielfoto',
      upload: 'Foto uploaden',
    },
  },
  integrations: {
    accountant: {
      current: 'Onderstaande boekhouder is toegevoegd aan je account:',
      description:
        'Door je boekhouder toe te voegen, krijgt die toegang tot je facturen en documenten via het Credit-platform van Creative Shelter.',
      pair: 'Toevoegen',
      requested: 'Onderstaande boekhouder heeft toegang gevraagd tot je account:',
      title: 'Geef je boekhouder toegang',
      unpair: 'Verwijderen',
    },
    description: 'Koppel hier je Creative Shelter-account met externe services.',
    externalSystems: {
      createAccount: 'Account aanmaken',
      description:
        'Koppel hier met je boekhoudpakket om de facturen en creditnota’s automatisch door te sturen. Let wel, dit is geen koppeling met je Peppol-inbox.',
      pairWith: 'Koppelen met {{ system }}',
      paired: 'Gekoppeld',
      peppolWarning:
        'Facturen en creditnota’s die via Peppol verstuurd worden, kunnen dubbel binnenkomen in je koppeling. Controleer de instellingen van je boekhoudpakket om een dubbele verwerking te vermijden.',
      systems: {
        billit: {
          description:
            'Maak je naast creatieve facturen ook wel eens niet-creatieve facturen aan? Deze integratie maakt het mogelijk om die niet-creatieve facturen eenvoudig aan te maken en te koppelen aan je Creative Shelter-account.',
          name: 'Billit',
        },
        cashaca: {
          description: 'Cashaca vereenvoudigt je boekhouding. Dit is ideaal voor zelfstandigen met een omzet van minder dan € 500.000.',
          modal: {
            apiToken: 'API-code van Cashaca',
            description:
              'Geef hier je persoonlijke API-code van Cashaca in.<br/>Heb je nog geen Cashaca-account? <a href="https://app.cashaca.be/gebruikers/registreer?utm_source=creativeshelter" target="_blank">Registreer je dan hier</a>.',
          },
          name: 'Cashaca',
        },
        dexxter: {
          alerts: {
            error: 'Er ging iets mis bij het koppelen van je Dexxter-account.',
            success: 'Je bent gekoppeld met je Dexxter-account.',
          },
          description:
            'Je facturen en creditnota’s, automatisch in Dexxter. Zo’n platform om als eenmanszaak je boekhouding zelf te doen, binnen handbereik.',
          modal: {
            description:
              'Stuur je facturen en creditnota’s automatisch door naar Dexxter in twee snelle stappen:<ol><li>Ga naar je instellingen en klik op ‘<dexxterLink href="https://go.dexxter.be/user-settings/general/company-settings">Algemeen</dexxterLink>’. Vink de optie ‘Activeer auteursrechten’ aan en sla op.</li><li>Ga naar ‘Inkomsten’ en klik op ‘<dexxterLink href="https://go.dexxter.be/income-documents">Inbox</dexxterLink>’. Binnen de inbox klik je op ‘Bekijk aanlevermethode’ en kopieer je het e-mailadres van je digitale brievenbus. Deze plak je hieronder.</li></ol>',
            emailAddress: {
              placeholder: 'income.xxxxxxxxxxxxxxxx',
              suffix: '@inbound.dexxter.be',
              validatePrefix: 'Het e-mailadres moet starten met ‘income.’.',
              validateSuffix: 'Vul alleen in wat er voor de ‘@’ staat.',
            },
            title: 'Koppelen met Dexxter',
            titleTooltip:
              'Meer info lees je <faqLink href="https://www.creativeshelter.be/knowledge-hub/hoe-stuur-ik-mijn-facturen-automatisch-door-naar-dexxter">in onze FAQ</faqLink>.',
          },
          name: 'Dexxter',
          tag: 'Krijg € 25 korting',
        },
      },
      title: 'Koppelen aan externe systemen',
    },
    forwarding: {
      add: 'Ontvanger toevoegen',
      blocker: 'Ben je zeker dat je de pagina wilt verlaten? De wijzigingen aan je doorstuuradres zijn niet opgeslagen.',
      deleteModal: {
        confirm: 'Ja, ik ben zeker.',
        description: 'Ben je zeker dat je je facturen en creditnota’s niet langer wilt doorsturen naar {{email}}?',
        dexxter: {
          confirm: 'Verwijder koppeling',
          description: 'Ben je zeker dat je je facturen en creditnota’s niet meer automatisch wilt doorsturen naar Dexxter?',
          title: 'Dexxter-koppeling verwijderen',
        },
        title: 'Stoppen met automatisch doorsturen',
      },
      description:
        'Stuur je facturen en creditnota’s automatisch door naar je boekhouder of boekhoudpakket. <a href="https://www.creativeshelter.be/knowledge-hub/kan-ik-mijn-documenten-automatisch-doorsturen-naar-mijn-accountant" target="_blank">We leggen het hier voor je uit.</a>',
      peppol: {
        description:
          'Al je facturen ontvang je in je Peppol-inbox. Deze automatisch doorsturen of koppelen met een extern systeem hoeft niet meer, tenzij dit specifiek is gevraagd.',
        title: 'Peppol is geactiveerd',
      },
      title: 'Automatisch doorsturen',
    },
    pair: 'Koppelen',
    peppol: {
      actions: {
        checkAgain: 'Controleer opnieuw',
      },
      confirmExtraIntegration: {
        cancel: 'Niet koppelen',
        confirm: 'Toch koppelen',
        description:
          'Je ontvangt je facturen al in je Peppol-inbox. Een extra koppeling is (meestal) niet nodig, tenzij je boekhouder of boekhoudpakket er specifiek om vraagt. Ben je zeker dat je wil verdergaan?',
        title: 'Extra koppeling nodig?',
      },
      description:
        'Het is de gestructureerde manier om documenten te versturen en te ontvangen. En vooral: verplicht sinds 2026, ook voor jou.\n',
      disclaimerSelfBillingUnsupported:
        '<bold>Vanaf 1 januari 2026 versturen we je facturen via Peppol, je bent dus wettelijk in orde.</bold><br>\nJe Peppol-inbox ondersteunt (nog) <strong>geen self-billing</strong>. Daardoor komen je facturen mogelijk nog niet automatisch in je boekhouding terecht. <strong>Als alternatief</strong> kan je via onze <strong>‘automatisch doorsturen’-instelling</strong> je facturen ook vanzelf in je boekhouding ontvangen.',
      fields: {
        peppolId: {
          empty: 'Nog geen Peppol-ID',
          label: 'Peppol-ID',
          tooltip:
            'We vonden deze Peppol-ID voor jou. Niet juist? <email href="mailto:service@creativeshelter.be">Mail ons</email>, wij passen het voor je aan.',
        },
        status: {
          label: 'Status',
          options: {
            Active: 'Geactiveerd',
            ActiveSelfBillingFallback: 'Self-billing niet geactiveerd',
            NotRegistered: 'Geen Peppol-ID gevonden',
          },
        },
      },
      title: 'Peppol',
    },
    processing: 'We halen je data op',
    title: 'Integraties',
    unpair: 'Ontkoppelen',
  },
  nps: {
    ariaLabelTextarea: 'Schrijf hier je mening',
    eyebrow: 'Je mening telt',
    placeholderTextarea: 'Deel hier je mening',
    sendFeedback: 'Feedback versturen',
    titleStepOne: 'In welke mate zou je Creative Shelter aanbevelen bij andere freelancers?',
    titleStepThree: 'Bedankt! We gaan met je feedback aan de slag!',
  },
  profile: {
    activities: {
      title: 'Activiteiten',
      warnings: {
        stylingAndInterior: {
          body: 'Vanaf 2024 komen niet alle creatieve styling- en interieurprestaties nog in aanmerking voor een auteursvergoeding. De interpretatie van de wet is strenger dan de wet zelf. Twijfel je of je prestatie in aanmerking komt? <a href="mailto:administratie@creativeshelter.be?subject=Komen mijn prestaties voor styling/interieur nog in aanmerking?" target="_blank">Mail ons</a>, en we pikken het verder met je op. Voor andere creatieve activiteiten kom je nog steeds in aanmerking.',
          title: 'Belangrijk! Stylist of interieurvormgever? Lees dan even verder.',
        },
      },
    },
    brands: {
      add: 'Handelsnaam toevoegen',
      delete: {
        description: 'Ben je zeker dat je “{{brand}}” wilt verwijderen?',
        title: 'Handelsnaam verwijderen',
      },
      description: 'Bekijk, creëer en bewerk je handelsnamen.',
      edit: 'Handelsnaam aanpassen',
      favorite: {
        markAsFavorite: 'Aanduiden als favoriet',
        removeFavorite: 'Verwijderen als favoriet',
      },
      headers: {
        color: 'Kleur handelsnaam',
        email: 'E-mailadres',
        logo: 'Logo',
        name: 'Je handelsnaam',
      },
      logoAdd: 'Logo toevoegen',
      logoEdit: 'Logo bewerken',
      mainBrand: 'Hoofdhandelsnaam',
      title: 'Handelsnamen',
    },
    community: {
      communityHidden:
        'De toegang tot de Community werd voor jou uitgeschakeld. Voor meer info mag je ons altijd <a href="mailto:admin@creativeshelter.be?subject=Geblokkeerde toegang Community" target="_blank">een e-mail sturen</a>.',
      description: 'Pas hier je Community-profiel aan',
      title: 'Community',
      visibleInCommunity: 'Zichtbaar in Community',
    },
    financial: {
      bank: 'Naam bank',
      bic: 'BIC/SWIFT',
      check: 'Checken',
      error: {
        foreignIban: 'Er ging iets mis bij het ophalen van je bankinformatie. Vul je deze zelf even aan?',
        general: 'Er ging iets mis bij het opslaan van je rekeningnummer.',
      },
      iban: 'Rekeningnummer',
      title: 'Bankgegevens',
    },
    info: {
      companyTitle: 'Je eenmanszaakgegevens',
      kboDescription: 'Deze gegevens komen uit de databank van de KBO.',
      language: {
        en: 'Engels',
        fr: 'Frans',
        nl: 'Nederlands',
      },
      refreshKboInformation: {
        action: 'Gegevens refreshen',
        lastUpdated: '{{timeAgo}} geüpdatet uit de KBO',
        tooltip:
          'De gegevens halen we rechtstreeks op uit de <kboLink>Kruispuntbank van Ondernemingen</kboLink> (KBO in ’t kort). Zijn ze niet meer up-to-date? Dan kan je hier de nieuwste gegevens ophalen. Alleen mogelijk als de gegevens ouder zijn dan 7 dagen.',
        unavailable_one: 'Je kan je gegevens over 1 dag opnieuw refreshen.',
        unavailable_other: 'Je kan je gegevens over {{count}} dagen opnieuw refreshen.',
      },
      subsections: {
        kbo: 'Gegevens onderneming',
        personal: 'Persoonlijke informatie',
      },
      title: 'Profielinformatie',
    },
    password: {
      edit: 'Wachtwoord wijzigen',
      title: 'Wachtwoord veranderen',
    },
    title: 'Profiel',
    vatRegulation: {
      description: 'Hier vind je extra informatie over je huidige btw-statuut.',
      edit: 'Aanpassen',
      help: 'Duid aan welk btw-statuut je gebruikt. Dit bepaalt of er btw wordt aangerekend op je facturen. Kleine ondernemingen met een omzet onder € 25.000 kunnen de standaard btw-vrijstellingsregeling volgen. Dit kan je zelf aanvragen. Meer informatie vind je <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">hier</a>.',
      info: {
        none: 'Je hebt je btw-statuut nog niet aangeduid.',
        vatExempt:
          'Je maakt gebruik van de <strong>standaard btw-vrijstellingsregeling</strong>. Facturen tussen jou en Creative Shelter worden opgemaakt zonder btw. Volg hieronder op hoe ver je van de limiet zit.',
        vatNormal:
          'Je maakt gebruik van het <strong>gewone btw-statuut</strong>. Facturen tussen jou en Creative Shelter worden opgemaakt met btw.',
      },
      limit: 'Limiet vrijstellingsregeling {{year}}',
      options: {
        vatExempt: {
          description: 'Kleine ondernemingen met een omzet onder de € 25.000',
        },
        vatNormal: {
          description: 'Ondernemingen met een omzet meer dan € 25.000',
        },
      },
      title: 'Btw-statuut',
      toggle: {
        vatExempt: 'Btw-vrijgesteld',
        vatNormal: 'Btw-plichtig',
      },
      toggleDescription: {
        vatExempt: 'Kleine ondernemingen met een omzet lager dan € 25.000',
        vatNormal: 'Ondernemingen met een omzet hoger dan € 25.000',
      },
      tooltip: 'Als je omzet hoger is dan € 25.000, mag je geen gebruik meer maken van de standaard btw-vrijstellingsregeling.',
      totalRevenueInYear: 'Totale omzet {{ year }}',
      yearSelector: {
        ariaLabel: 'Selecteer het jaar waarvoor je de omzetlimiet wilt bekijken.',
      },
    },
  },
  prompts: {
    verifyAddress: {
      change: {
        actions: {
          back: 'Terug',
          mail: 'Mail ons',
        },
        description: 'Verhuisd? Laat het ons weten! Stuur een e-mail met je nieuwste adresgegevens, dan passen wij het aan in je profiel.',
        kboMessage:
          'Tip! Geef je nieuwste adresgegevens ook door aan de Kruispuntbank van Ondernemingen (via <myEnterpriseLink>My Enterprise</myEnterpriseLink>).',
        mailLink: 'mailto:service@creativeshelter.be?subject=Ik heb een nieuw adres&body=Hey%0D%0A%0D%0AMijn nieuwe adres is',
        title: 'Adres aanpassen graag!',
      },
      verify: {
        actions: {
          confirm: 'Ja, correct!',
          edit: 'Nog niet juist, aanpassen graag!',
          refresh: 'Gegevens opnieuw ophalen',
        },
        description: 'Onderstaande gegevens zijn ingevuld in je profiel, dubbelcheck je je adres even?',
        errors: {
          refreshKboFailed: 'Je gegevens kunnen nu niet worden opgehaald uit de Kruispuntbank van Ondernemingen.',
        },
        title: 'Dubbelcheck je adres',
      },
    },
  },
  tabs: {
    company: 'Bedrijfsgegevens',
    email: 'Meldingen',
    integrations: 'Integraties',
    invoice: 'Factuurinstellingen',
    profile: 'Profiel',
  },
  unsavedChanges: {
    description: 'Sla je wijzigingen op voor je verdergaat, of verwijder ze om zonder opslaan verder te gaan.',
    discard: 'Wijzigingen annuleren',
    save: 'Wijzigingen opslaan',
    title: 'Je hebt niet-opgeslagen wijzigingen',
  },
};
